import React, { useState, useEffect } from "react";

import { Calendar } from "./calendar";

import Dialog from "./dialog";
import Utils from "../../../helpers/utils";
import AppTheme from "../AppTheme";

export default function DatePickerDialog({
  value,
  controller,
  isOpen = false,
  onConfirm = () => {},
  onClose = () => {},
}) {
  const now = Utils.nowUserTz(controller);
  const [today] = useState(now.format("YYYY-MM-DD"));
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  useEffect(() => {
    setIsDialogOpen(isOpen);
  }, [isOpen]);

  return (
    <>
      {isDialogOpen ? (
        <Dialog.Container onClose={onClose} showCloseButton>
          <Calendar
            theme={{
              backgroundColor: "#E6F9F3",
              calendarBackground: "#FFF",
              textSectionTitleColor: "#b6c1cd",
              textSectionTitleDisabledColor: "#d9e1e8",
              selectedDayTextColor: "#ffffff",
              dayTextColor: "#2d4150",
              arrowColor: "#000",
              monthTextColor: "#000",
              textDayFontWeight: "400",
              textMonthFontWeight: "bold",
              textDayHeaderFontWeight: "300",
              textDayFontSize: 16,
              textMonthFontSize: 16,
              textDayHeaderFontSize: 16,
            }}
            markedDates={{
              [today]: {
                marked: true,
                dotColor: "#925BE8",
                color: "#000",
              },
              [value]: {
                selected: true,
                backgroundColor: AppTheme.DEFAULT_COLOR,
                color: "#FFF",
              },
            }}
            current={today}
            monthFormat={"MMMM yyyy"}
            onDayPress={(day) => onConfirm(day.dateString)}
            firstDay={7}
          />
        </Dialog.Container>
      ) : null}
    </>
  );
}
